/**
 * Minimal set of BAS accounts activated when a company is created.
 * Keep these lists short: everything else is activated on demand with user
 * confirmation. Every number here must exist in the BAS reference table.
 */
import type { EntityType } from '../types';

/**
 * Shared by every entity: the default payment sources (1930 Företagskontot,
 * 1910 Kontant), invoice credits (1510/2440), VAT accounts and two catch-alls.
 * The owner account behind "Egna pengar" is entity-specific and listed below
 * (EF 2018/2013, AB/förening/BRF 2893).
 */
const COMMON = [1910, 1930, 1510, 2440, 2610, 2640, 2650, 6570, 6991] as const;

const BY_ENTITY: Record<EntityType, readonly number[]> = {
  aktiebolag: [...COMMON, 2081, 2091, 2098, 2099, 2510, 2893, 3001, 8910, 8999],
  enskild_firma: [...COMMON, 2010, 2013, 2018, 2019, 3001, 8999],
  ideell_forening: [1910, 1930, 1510, 2440, 2061, 2067, 2069, 2893, 3890, 3989, 6570, 6991, 8999],
  bostadsrattsforening: [1110, 1119, 1910, 1930, 1510, 2083, 2088, 2091, 2099, 2350, 2440, 2893, 3910, 5170, 5190, 6570, 7820, 8410, 8999],
};

export function starterAccountNumbers(entityType: EntityType): readonly number[] {
  return BY_ENTITY[entityType];
}
